import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";  
import './Herosection.css';

const Herosection = () => {
    return (
        <div className="hero-section">
            <div className="container">
                <div className="row align-items-center" style={{ minHeight: "100vh" }}>
                        <h1 className="custom-text">
                        GETTING STARTED IMPORTING FROM CHINA TO INDIA: GETTING STARTED When importing from China, do you wish to reduce expenses and control risks?
                        </h1>
                </div>
            </div>
        </div>
    );
};

export default Herosection;

